import {api} from "../services/api";

export const getFaqAPI = () => {
  return api.get(`/api/Application/GetFAQDetails`);
}